import {Injectable} from '@angular/core';
import {FlatArea} from '../models/flat-area.model';
import {Flat} from '../models/flat.model';

@Injectable({
  providedIn: 'root'
})
export class FlatUtilService {

  constructor() {
  }


  getTerraceSize(flat: Flat) {
    if (flat || !flat.flatAreas) {
      return 0;
    }
    const terrace = flat.flatAreas.filter(item => item.name === 'terasz');
    let terraceSize = 0;
    terrace.forEach((flatArea: FlatArea) => {
      terraceSize = terraceSize + flatArea.size;
    });
    return terraceSize;
  }

}
